import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DropdownMenuItem } from "~/atoms/dropdown-menu";
import { ManageFrameworkDropdown } from "~/molecules/ManageFrameworkDropdown";
import { CategoryModal } from "~/organisms/category-modal/CategoryModal";
import { ReorderCategoryModal } from "~/organisms/ReorderCategoryModal";

export function ManageCategoriesDropdown() {
  const { t } = useTranslation();
  const [activeDialog, setActiveDialog] = useState<"create" | "reorder" | null>(
    null,
  );

  return (
    <>
      <ManageFrameworkDropdown
        label={t(($) => $.commons.buttons.manageCategories)}
      >
        <DropdownMenuItem onSelect={() => setActiveDialog("create")}>
          {t(($) => $.commons.buttons.createCategory)}
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => setActiveDialog("reorder")}>
          {t(($) => $.commons.buttons.reorderCategories)}
        </DropdownMenuItem>
      </ManageFrameworkDropdown>

      <CategoryModal
        open={activeDialog === "create"}
        onOpenChange={(open) => !open && setActiveDialog(null)}
      />
      <ReorderCategoryModal
        open={activeDialog === "reorder"}
        onOpenChange={(open) => !open && setActiveDialog(null)}
      />
    </>
  );
}
